import React, { Component, Fragment } from 'react'
import * as Icons from 'react-feather'
import Dropzone from 'react-dropzone'
import { withStyles } from '@material-ui/core/styles'
import { styles } from '../../styles/client'
import { getSelectedClients } from '../../data/interactions'
import { requestAPI, post } from '../../data/api.js'
import setAction from './setAction'
import { getApiBase } from '../../config'
import { getModel, updateModel } from '../../data/Model'
import Loading from '../../generic/Loading'
import CountrySelect from './CountrySelect'
import DnsLookupButton from './DnsLookupButton'
import {
	TextField,
	FormControlLabel,
	Checkbox,
	RadioGroup,
	Radio,
	Tooltip,
} from '@material-ui/core'

export const formatDisplayUrl = (urlRaw) => {
	const url = new URL(urlRaw)

	return `${url.host}${url.pathname}${url.search}`
}

const rejectReasonOther = { id: 'other', text: 'OTHER REASON' }

const rejectReasonMulticase = { id: 'multicase', text: 'Multicase' }

const rejectReasonsAdditional = [
	{
		id: 'blacklistDomain',
		text: 'Blacklist Domain',
		tooltip:
			'You ask to remove the entire domain from all future scans for all partners',
	},
	{
		id: 'blacklistImage',
		text: 'Blacklist Image',
		tooltip: 'You ask to remove the image from all future scans',
	},
]

const rejectReasonsForFiltering = [
	{
		id: 'redirect',
		text: 'Site redirect',
		tooltip: 'Entering the site redirects to another domain',
	},
	{ id: 'byline', text: 'Byline', tooltip: 'Image is correctly bylined' },
]

class Violation extends Component {
	constructor(props, context) {
		super(props, context)
		this.apiBase = getApiBase()

		this.state = {
			loadingScreenshot: false,
			loadingAction: false,
			internalComment: props.violation.internal_comment || '',
			commentSaved: false,
			manipulated: props.violation.manipulated || false,
			violation_type: props.violation.violation_type,

			url_raw: props.violation.url_raw,
			showAccurateUrlForm: false,
			accurateUrl: '',
			accurateUrlError: '',
			clientId: getSelectedClients()[0].client_id,
			soft_claim: props.violation.soft_claim,
			currentUserEmail: this.props.email,
			screenshots: [],
			rejectReason: '',
			cachedAction: null, // For stage 3: stores pending action before sending
			lastClickedAction: null, // Tracks last clicked action for highlighting
			pdf: !!props.violation.pdf,
		}
	}

	async componentDidMount() {
		// GRM: I needed to add this hook to initialize
		// this state variable from an async call. Feedback on other ways to do this welcome
		this.loadScreenshots()
	}

	renderDnsLink() {
		const domain = this.props.violation.domain
		if (!domain) return null
		let url = `https://www.whois.com/whois/${domain}`
		let label = domain
		let isFR = false
		if (domain.endsWith('.be')) {
			url = `https://www.dnsbelgium.be/nl/whois/info/${domain}/details`
		} else if (domain.endsWith('.nl')) {
			url = `https://www.sidn.nl/whois/?q=${domain}/details`
		} else if (domain.endsWith('.fr')) {
			url = `https://www.eurodns.com/`
			isFR = true
		} else if (domain.endsWith('.eu')) {
			url = `https://whois.eurid.eu/en/search/?domain=${domain}`
		}
		if (isFR) {
			return (
				<p>
					DNS:{' '}
					<a
						href='#'
						style={{ color: 'blue', textDecoration: 'underline' }}
						onClick={(e) => {
							e.preventDefault()
							if (navigator.clipboard) {
								navigator.clipboard.writeText(domain)
							}
							window.open(url, '_blank', 'noopener,noreferrer')
						}}
					>
						{label}
					</a>{' '}
					<span style={{ fontSize: '0.85em', opacity: 0.7 }}>(copied)</span>
					{' | '}
					<a
						href={`/statistics?domain=${encodeURIComponent(domain)}`}
						style={{
							color: 'blue',
							textDecoration: 'underline',
							fontSize: '0.9em',
						}}
					>
						View Domain Stats
					</a>
				</p>
			)
		}
		return (
			<p>
				DNS:{' '}
				<a
					href={url}
					target='_blank'
					rel='noopener noreferrer'
					style={{ color: 'blue', textDecoration: 'underline' }}
				>
					{label}
				</a>
				{' | '}
				<a
					href={`/statistics?domain=${encodeURIComponent(domain)}`}
					style={{
						color: 'blue',
						textDecoration: 'underline',
						fontSize: '0.9em',
					}}
				>
					View Domain Stats
				</a>
			</p>
		)
	}

	renderViolationId() {
		const { violation_id } = this.props.violation
		if (!violation_id) return null
		return (
			<p
				style={{
					fontSize: '0.85em',
					fontFamily: 'monospace',
					color: 'rgba(0,0,0,0.6)',
					margin: '2px 0',
				}}
			>
				Violation ID: {violation_id}
			</p>
		)
	}

	renderCasePrepLink() {
		const { violation } = this.props
		if (!violation.case_prep_outcome) return null
		const casePrepBaseUrl =
			process.env.REACT_APP_CASE_PREP_URL ||
			'https://prepare.copyrightagent.com'
		const url = `${casePrepBaseUrl}/cases/lookup?violationId=${encodeURIComponent(violation.violation_id)}`
		const label = `Case prep: ${violation.case_prep_outcome}`
		return (
			<p style={{ margin: '2px 0' }}>
				<a
					href={url}
					target='_blank'
					rel='noopener noreferrer'
					style={{
						color: 'blue',
						textDecoration: 'underline',
						fontSize: '0.9em',
					}}
				>
					{label}
				</a>
				{violation.case_prep_occurred_at && (
					<span style={{ fontSize: '0.8em', opacity: 0.6, marginLeft: '6px' }}>
						({new Date(violation.case_prep_occurred_at).toLocaleDateString()})
					</span>
				)}
			</p>
		)
	}
	screenshotImageUrl = (uri) => {
		const token = getModel().auth_token
		return `${this.apiBase}/screenshots/image?uri=${encodeURIComponent(uri)}&auth_token=${encodeURIComponent(token)}`
	}

	loadScreenshots = async () => {
		const data = await requestAPI(
			`/screenshots?violation_id=${this.props.violation.violation_id}`,
			'GET',
		)
		this.setState({ screenshots: Array.isArray(data) ? data : [] })
	}

	handleMouseEnter = (e) => {
		e.target.querySelector('img').style.visibility = 'hidden'
		const src = e.target.querySelector('img').src
		this.setState({ backgroundImage: `url(${src})` })
	}

	handleMouseMove = (e) => {
		const { left, top, width, height } = e.target.getBoundingClientRect()
		const x = ((e.pageX - left) / width) * 100
		const y = ((e.pageY - top) / height) * 100
		this.setState({ backgroundPosition: `${x}% ${y}%` })
	}

	handleMouseLeave = (e) => {
		e.target.querySelector('img').style.visibility = 'visible'
	}

	markViolationCommercial = async (e) => {
		const { violation } = this.props
		const previousType = this.state.violation_type

		this.setState({ violation_type: 'Commercial', violationTypeError: null })

		try {
			await post(`/cases/mark-commercial?clientId=${this.state.clientId}`, {
				case_id: violation.violation_id,
			})
		} catch (error) {
			this.setState({
				violation_type: previousType,
				violationTypeError: `Could not save the claim type: ${error.message}`,
			})
		}
	}

	markViolationEditorial = async (e) => {
		const { violation } = this.props
		const previousType = this.state.violation_type

		this.setState({ violation_type: 'Editorial', violationTypeError: null })

		try {
			await post(`/cases/mark-editorial?clientId=${this.state.clientId}`, {
				case_id: violation.violation_id,
			})
		} catch (error) {
			this.setState({
				violation_type: previousType,
				violationTypeError: `Could not save the claim type: ${error.message}`,
			})
		}
	}

	switchSoftClaim = async () => {
		const {
			violation: { violation_id: caseId },
		} = this.props
		const { clientId, soft_claim } = this.state
		const newSoftClaimStatus = !soft_claim

		this.setState({ soft_claim: newSoftClaimStatus, softClaimError: null })

		try {
			if (newSoftClaimStatus) await markSoftClaim(clientId, caseId)
			else await unmarkSoftClaim(clientId, caseId)
		} catch (error) {
			this.setState({
				soft_claim,
				softClaimError: `Could not save soft claim: ${error.message}`,
			})
		}
	}

	toggleViolationReviewRequired = async (e) => {
		const { violation } = this.props
		const { checked: client_review_required } = e.target

		await requestAPI(
			`/violations/${violation.violation_id}/setClientReviewRequired`,
			'PATCH',
			{ client_review_required },
		)

		this.setState({ client_review_required })
	}

	markAsManipulated = (violation) => async (event) => {
		const checked = event.target.checked
		await this.setState((s) => ({
			manipulated: checked,
		}))
		await requestAPI(
			`/violations/update/${violation.violation_id}/manipulated`,
			'POST',
			{ manipulated: this.state.manipulated },
		)
	}

	markAsPdf = (violation) => async (event) => {
		const checked = event.target.checked
		await this.setState((s) => ({
			pdf: checked,
		}))
		await requestAPI(
			`/violations/update/${violation.violation_id}/pdf`,
			'POST',
			{ pdf: this.state.pdf },
		)
	}

	rejectAsInaccurateUrl = async (e) => {
		e.preventDefault()
		const { violation } = this.props

		try {
			new URL(this.state.accurateUrl)
		} catch {
			return this.setState({ accurateUrlError: 'Please enter a valid URL' })
		}

		this.setState({ accurateUrlError: '' })

		const result = await requestAPI(
			`/violations/${violation.violation_id}/inaccurate-url`,
			'POST',
			{
				accurateUrl: this.state.accurateUrl,
				stage: this.props.proxyPermissionLevel,
			},
		)
		if (result.status === 'error') return alert(result.message)

		this.setState({ showAccurateUrlForm: false })

		updateModel((model) => {
			model.assignedViolations.data.violations =
				model.assignedViolations.data.violations.filter(
					(v) => v.violation_id !== violation.violation_id,
				)
			return model
		})
	}

	renderManualBadge = () => {
		if (this.props.violation.scan_location !== 'manual') return null
		return (
			<div
				style={{
					background: '#fde2e1',
					border: '2px solid #d32f2f',
					borderRadius: '4px',
					padding: '8px 12px',
					margin: '0 0 8px',
					display: 'flex',
					alignItems: 'center',
					gap: '8px',
				}}
			>
				<Icons.AlertTriangle size={18} color='#d32f2f' />
				<span style={{ color: '#b71c1c', fontWeight: 'bold' }}>
					MANUAL SUBMISSION — review with extra care.
				</span>
			</div>
		)
	}

	renderUrl = () => {
		const { violation } = this.props
		return (
			<h2 style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
				<a href={this.state.url_raw} target='_blank' rel='noopener noreferrer'>
					<p className='url'>
						<img alt='' height='20' src={violation.favicon} />{' '}
						{formatDisplayUrl(this.state.url_raw)}
					</p>
				</a>
			</h2>
		)
	}

	renderMulticaseWarning = (multiCase) => {
		if (multiCase && multiCase.case_count)
			return (
				<div className='warning-multi-case'>
					<p className=''>Previous case on domain:</p>
					<div className='item-container'>
						{multiCase.multicase_count > 0 && (
							<div className='item'>
								Multi case ({multiCase.multicase_count})
							</div>
						)}
						{multiCase.unique_counterparties > 0 && (
							<div className='item'>
								Unique CP ({multiCase.unique_counterparties})
							</div>
						)}
						{multiCase.objections > 0 && (
							<div className='item'>Objected ({multiCase.objections})</div>
						)}
						{multiCase.lost > 0 && (
							<div className='item'>Closed/lost ({multiCase.lost})</div>
						)}
						{multiCase.legalAction > 0 && (
							<div className='item'>Legal action ({multiCase.legalAction})</div>
						)}
						{multiCase.rejected > 0 && (
							<div className='item'>Rejected ({multiCase.rejected})</div>
						)}
					</div>
				</div>
			)
	}

	getActionByRole = (violationActions, role) => {
		if (!violationActions.length) return null
		const violationActionsByRole = violationActions.find(
			(action) => action.permission_level === role,
		)
		if (!violationActionsByRole) return null
		return {
			reason: violationActionsByRole.reason
				? violationActionsByRole.reason
				: 'other',
			isViolating: violationActionsByRole.is_violating,
		}
	}

	getIsViolating = (violationActions) => {
		if (!violationActions.length) return ''
		return violationActions[violationActions.length - 1].is_violating
	}

	setPreferredScreenshot = async (screenshotUri) => {
		await requestAPI(
			`/violations/set_preferred_screenshot/${this.props.violation.violation_id}`,
			'POST',
			{ screenshot_uri: screenshotUri },
		)
		await this.loadScreenshots()
	}

	render() {
		const { classes, proxyPermissionLevel, violation } = this.props
		const violation_actions =
			violation.actions.length > 1
				? violation.actions.sort(
						(l, r) =>
							new Date(l.reg_date).valueOf() - new Date(r.reg_date).valueOf(),
					)
				: violation.actions
		const isLastActionViolating = this.getIsViolating(violation_actions)
		const actionByRole = this.getActionByRole(
			violation_actions,
			proxyPermissionLevel,
		)
		const displayAction = this.state.lastClickedAction || actionByRole
		const rejectReasonsPerRole =
			'customer' === proxyPermissionLevel
				? [rejectReasonOther, rejectReasonMulticase, ...rejectReasonsAdditional]
				: [
						rejectReasonOther,
						...rejectReasonsAdditional,
						...rejectReasonsForFiltering,
					]

		return (
			<div className='violation' id={`${this.props.violation.violation_id}`}>
				{this.renderManualBadge()}
				<div
					className='row'
					style={{
						border: '1px solid black',
					}}
				>
					<div className='col-md-8'>
						<Dropzone
							onDrop={this.onDrop}
							acceptStyle={{
								opacity: 0.3,
							}}
							rejectStyle={{
								background: 'red',
							}}
							accept='image/jpeg, image/png'
							style={{
								border: violation.screenshot ? '' : '3px dashed #ddd',
								textAlign: 'center',
								cursor: 'pointer',
							}}
						>
							{(() => {
								const preferred = this.state.screenshots.find(
									(s) => s.is_preferred,
								)
								if (!preferred)
									return (
										<h2 style={{ margin: '153px 0px 140px', opacity: 0.5 }}>
											Upload screenshot
										</h2>
									)
								return (
									<figure
										onMouseMove={this.handleMouseMove}
										onMouseEnter={this.handleMouseEnter}
										onMouseLeave={this.handleMouseLeave}
										style={{
											backgroundPosition: this.state.backgroundPosition,
											backgroundImage: this.state.backgroundImage,
										}}
									>
										<img
											ref={(elm) => {
												this.img = elm
											}}
											alt=''
											src={this.screenshotImageUrl(preferred.screenshot_uri)}
											width='100%'
											style={{
												opacity: this.state.loadingScreenshot ? 0.5 : 1,
												pointerEvents: 'none',
											}}
										/>
									</figure>
								)
							})()}
						</Dropzone>
						{proxyPermissionLevel === 'agent' &&
							(() => {
								const others = this.state.screenshots.filter(
									(s) => !s.is_preferred,
								)
								if (!others.length) return null
								return (
									<div
										style={{
											display: 'flex',
											gap: '8px',
											marginTop: '8px',
											flexWrap: 'wrap',
										}}
									>
										{others.map((s) => (
											<div
												key={s.screenshot_uri}
												onClick={() =>
													this.setPreferredScreenshot(s.screenshot_uri)
												}
												style={{ cursor: 'pointer' }}
											>
												<img
													onError={(e) => (e.target.style.display = 'none')}
													alt=''
													src={this.screenshotImageUrl(s.screenshot_uri)}
													width='100'
													style={{
														display: 'block',
														borderRadius: '4px',
														border: '2px solid #ddd',
														opacity: this.state.loadingScreenshot ? 0.5 : 1,
													}}
												/>
												<div
													style={{
														fontSize: '0.75em',
														textAlign: 'center',
														color: '#666',
														marginTop: '2px',
													}}
												>
													{s.capture_method}
												</div>
											</div>
										))}
									</div>
								)
							})()}
						{(() => {
							const preferred = this.state.screenshots.find(
								(s) => s.is_preferred,
							)
							const ts =
								(preferred && preferred.captured_at) ||
								violation.screenshot_timestamp
							if (!ts) return null
							const ageMs = Date.now() - new Date(ts).getTime()
							const oneMonthMs = 30 * 24 * 60 * 60 * 1000
							if (ageMs <= oneMonthMs) return null
							const days = Math.floor(ageMs / (24 * 60 * 60 * 1000))
							const months = Math.floor(days / 30)
							const ageText =
								months >= 2
									? `${months} months`
									: days === 1
										? '1 day'
										: `${days} days`
							return (
								<div
									style={{
										background: '#fff3cd',
										border: '1px solid #ffc107',
										borderRadius: '4px',
										padding: '8px 12px',
										marginTop: '8px',
										display: 'flex',
										alignItems: 'center',
										gap: '8px',
									}}
								>
									<Icons.AlertTriangle size={16} color='#856404' />
									<span style={{ color: '#856404', fontSize: '0.875em' }}>
										Screenshot is {ageText} old
									</span>
								</div>
							)
						})()}
					</div>
					<div
						className='col-md-4'
						style={{
							borderLeft: '1px solid black',
						}}
					>
						<div className={classes.flexRow}>{this.renderUrl()}</div>
						<div>
							{proxyPermissionLevel === 'customer' &&
								this.renderMulticaseWarning(this.props.multiCase)}
						</div>
						<ul
							style={{
								marginBottom: '10px',
							}}
						>
							{this.renderDnsLink()}
							{this.renderViolationId()}
							{this.renderCasePrepLink()}Image found at destination:
							<p>
								Image Url:{' '}
								<a
									href={this.props.violation.destination_image_url}
									style={{ color: 'blue', textDecoration: 'underline' }}
									target='_blank'
								>
									{this.props.violation.destination_image_url}
								</a>
							</p>
							<img
								src={violation.destination_image_url}
								className='destinationImage'
								width='100%'
							/>
							{violation_actions.map((action, ix) => (
								<Action
									key={ix}
									action={action}
									violation={this.props.violation}
									onDeleteAction={(data) => this.onDeleteAction(data)}
								/>
							))}
							{this.state.loadingAction && (
								<li
									style={{
										listStyleType: 'none',
										paddingLeft: '5px',
										marginLeft: '20px',
									}}
								>
									<Loading width='15' />
								</li>
							)}
						</ul>
						<div>
							<button
								className={`btn primary ${(displayAction && displayAction.isViolating) || this.state.cachedAction ? 'active' : ''}`}
								style={{
									backgroundColor: this.state.cachedAction ? '#ff9800' : '',
									borderColor: this.state.cachedAction ? '#ff9800' : '',
								}}
								onClick={(e) => {
									e.preventDefault()
									// If there's a cached action, undo it; otherwise cache/send the action
									if (this.state.cachedAction) {
										this.undoCachedAction()
									} else {
										this.setAction(true)
									}
								}}
							>
								{this.state.cachedAction ? 'Undo Violating' : 'Violating'}
							</button>
							<fieldset className='radio-reason'>
								<legend>Not violating</legend>
								{rejectReasonsPerRole.map((reason, index) => (
									<div
										key={index}
										className={`btn radio secondary case-none ${displayAction && !displayAction.isViolating && displayAction.reason === reason.id ? 'active' : ''}`}
									>
										<input
											type='radio'
											id={`${reason.id}-${this.props.violation.violation_id}`}
											name='reason'
											value={reason.id}
											checked={
												displayAction &&
												!displayAction.isViolating &&
												displayAction.reason === reason.id
											}
											onChange={(e) => {
												e.preventDefault()
												this.setAction(false, e.target.value)
											}}
										/>
										<label
											htmlFor={`${reason.id}-${this.props.violation.violation_id}`}
										>
											{reason.text}
										</label>
										{reason.tooltip && (
											<Tooltip
												title={reason.tooltip}
												classes={{ tooltip: classes.tooltip }}
											>
												<Icons.HelpCircle
													style={{ height: '15px', zIndex: '1' }}
												/>
											</Tooltip>
										)}
									</div>
								))}
								<div
									style={
										this.state.showAccurateUrlForm
											? {
													border: '1px solid #ccc',
													borderRadius: '4px',
													padding: '8px',
												}
											: {}
									}
								>
									<button
										className='btn radio secondary case-none'
										onClick={(e) => {
											e.preventDefault()
											this.setState((s) => ({
												showAccurateUrlForm: !s.showAccurateUrlForm,
											}))
										}}
									>
										Inaccurate URL
									</button>
									{this.state.showAccurateUrlForm && (
										<form onSubmit={this.rejectAsInaccurateUrl}>
											<TextField
												className={classes.textField}
												label='Accurate URL'
												value={this.state.accurateUrl}
												onChange={(e) =>
													this.setState({
														accurateUrl: e.target.value,
														accurateUrlError: '',
													})
												}
												margin='normal'
												fullWidth
												error={!!this.state.accurateUrlError}
												helperText={this.state.accurateUrlError}
											/>
											<button className='btn primary' type='submit'>
												Submit
											</button>
										</form>
									)}
								</div>
							</fieldset>
							{proxyPermissionLevel === 'customer' && (
								<Fragment>
									<RadioGroup value={String(this.state.violation_type)} row>
										<FormControlLabel
											label={'Commercial'}
											labelPlacement='end'
											value={'Commercial'}
											control={<Radio color='default' />}
											onChange={this.markViolationCommercial}
										/>
										<FormControlLabel
											label={'Editorial'}
											labelPlacement='end'
											value={'Editorial'}
											control={<Radio color='default' />}
											onChange={this.markViolationEditorial}
										/>
									</RadioGroup>
									<FormControlLabel
										label={'Soft Claim'}
										labelPlacement='end'
										control={
											<Checkbox
												color='default'
												checked={this.state.soft_claim}
												onChange={this.switchSoftClaim}
												value='softClaim'
											/>
										}
									/>
									{(this.state.violationTypeError ||
										this.state.softClaimError) && (
										<div
											style={{
												color: '#b00020',
												fontSize: '13px',
												fontWeight: 600,
												padding: '4px 0',
											}}
										>
											{this.state.violationTypeError ||
												this.state.softClaimError}
										</div>
									)}
								</Fragment>
							)}
							{proxyPermissionLevel !== 'agent' && (
								<div>
									<FormControlLabel
										control={
											<Checkbox
												color='default'
												checked={this.state.manipulated}
												onChange={this.markAsManipulated(violation)}
												value='manipulated'
											/>
										}
										label='Manipulated'
									/>
									<FormControlLabel
										control={
											<Checkbox
												color='default'
												checked={this.state.pdf}
												onChange={this.markAsPdf(violation)}
												value='pdf'
											/>
										}
										label='PDF'
									/>
								</div>
							)}
						</div>
						<div>
							<CountrySelect
								violationId={violation.violation_id}
								initialMarket={violation.market}
							/>
						</div>
						<div>
							<form>
								<TextField
									className={classes.textField}
									label='Comment'
									value={this.state.internalComment}
									onChange={(event) =>
										this.setState({
											internalComment: event.target.value,
											commentSaved: false,
										})
									}
									margin='normal'
								/>
							</form>
							<button
								className='btn-save'
								onClick={() => {
									requestAPI(
										`/violations/update/${violation.violation_id}/internalComment`,
										'POST',
										{ internal_comment: this.state.internalComment },
									).then(() => {
										this.setState({ commentSaved: true })
									})
								}}
							>
								SAVE COMMENT
							</button>
							{this.state.commentSaved && (
								<span className='status-message sucess'>Comment is saved!</span>
							)}
						</div>
					</div>
				</div>
			</div>
		)
	}

	onUploadPhoto = async (photo) => {
		this.setState({ loadingScreenshot: true })
		const fileReaded = await this.promiseFileReader(photo)

		const response = await updateViolationScreenshot(
			this.props.violation.violation_id,
			{
				screenshot: fileReaded.split('base64,')[1],
				last_modified: photo.lastModified,
				name: photo.name,
			},
		)
		if (response.status) {
			this.setState({
				loadingScreenshot: false,
			})
			return alert('Something went wrong, try again!')
		}
		updateModel((model) => {
			/*const foundIndex = */ model.assignedViolations.data.violations.map(
				(violation) => {
					if (violation.violation_id === this.props.violation.violation_id)
						violation.screenshot = true
					return violation
				},
			)
			return model
		})
		this.setState({ loadingScreenshot: false })
		await this.loadScreenshots()
	}

	onDrop = (acceptedFiles, rejectedFiles) => {
		if (acceptedFiles.length > 0) {
			acceptedFiles.forEach((file) => {
				this.onUploadPhoto(file)
			})
		}
	}

	setAction = async (isViolating, rejectReason) => {
		this.setState({
			loadingAction: true,
			rejectReason: rejectReason,
			lastClickedAction: { isViolating, reason: rejectReason || 'other' },
		})

		if (
			this.props.proxyPermissionLevel === 'customer' &&
			!!isViolating &&
			!this.state.violation_type
		) {
			alert('You must define whether the violation is Commercial or Editorial')
			return this.setState({
				loadingAction: false,
			})
		}

		// In stage 3 (customer), cache the action locally instead of sending immediately
		if (this.props.proxyPermissionLevel === 'customer' && !!isViolating) {
			this.setState({
				cachedAction: { isViolating, rejectReason },
				loadingAction: false,
			})
			// Notify parent component about cached action
			if (this.props.onCachedActionChange) {
				this.props.onCachedActionChange(this.props.violation.violation_id, {
					isViolating,
					rejectReason,
				})
			}
			return
		}

		const permissionLevel =
			this.props.proxyPermissionLevel === 'rejected'
				? 'agent'
				: this.props.proxyPermissionLevel

		if (
			rejectReason === 'blacklistImage' ||
			rejectReason === 'blacklistDomain'
		) {
			await this.props.markRemainingViolationsAsNotViolating(
				permissionLevel,
				rejectReason,
			)
			return this.setState({
				loadingAction: false,
			})
		}

		const { newAction, updatedViolation } = await setAction(
			this.props.violation.violation_id,
			{
				is_violating: isViolating,
			},
			permissionLevel,
			rejectReason,
		)

		await updateModel((model) => {
			model.assignedViolations.data.violations = model.assignedViolations.data.violations.map(
				(violation) => {
					if (violation.violation_id === this.props.violation.violation_id) {
						updatedViolation.actions = [...violation.actions, newAction]
						return { ...violation, ...updatedViolation }
					}
					return violation
				},
			)
			return model
		})

		this.setState({
			loadingAction: false,
		})
	}

	// Method to undo cached action
	undoCachedAction = () => {
		this.setState({ cachedAction: null })
		if (this.props.onCachedActionChange) {
			this.props.onCachedActionChange(this.props.violation.violation_id, null)
		}
	}

	onDeleteAction = async ({ action, violation }) => {
		await deleteAction(
			action.violation_action_id,
			action.reason,
			action.violation_id,
			action.permission_level,
			action.user_id,
		)
		this.state.rejectReason = ''
		await updateModel((model) => {
			model.assignedViolations.data.violations = model.assignedViolations.data.violations.map(
				(v) => {
					if (v.violation_id === violation.violation_id) {
						v.actions = v.actions.filter(
							(a) => a.violation_action_id !== action.violation_action_id,
						)
					}
					return v
				},
			)
			return model
		})
	}

	promiseFileReader = async (photo) => {
		return new Promise((resolve, reject) => {
			const reader = new FileReader()
			reader.onload = async (event) => {
				resolve(event.target.result)
			}
			reader.readAsDataURL(photo)
		})
	}
}

const Action = ({ action, violation, onDeleteAction }, context) => {
	let violationType
	if (action.violation_type) {
		const violationTypes = getModel().violationTypes
		if (violationTypes.status.handle === 'loaded') {
			violationType = violationTypes.data.find((v) => {
				return v.violation_type === action.violation_type
			})
		}
	}
	const description = action.is_violating ? 'violating' : 'not-violating'

	return (
		<li
			style={{
				listStyleType: 'none',
				display: 'flex',
				alignItems: 'center',
				color: 'rgba(0, 0, 0, 0.87)',
			}}
		>
			{onDeleteAction && (
				<Icons.Delete
					style={{
						cursor: 'pointer',
						height: '10px',
					}}
					onClick={() => onDeleteAction({ action, violation })}
				/>
			)}
			<code>{action.permission_level}:</code>
			<div style={{ padding: '0 5px' }}>{description}</div>
			{action.reason && (
				<div
					style={{
						backgroundColor: '#ececec',
						padding: '0 4px',
						borderRadius: '2px',
					}}
				>
					{action.reason}
				</div>
			)}
		</li>
	)
}

function updateViolationScreenshot(violation_id, data) {
	return requestAPI(
		`/violations/upload_screenshot/${violation_id}`,
		'POST',
		data,
	)
}

function deleteAction(action_id, reason, violationId, permissionLevel, userId) {
	return requestAPI(`/violations/delete-action/${action_id}`, 'POST', {
		reason,
		violationId,
		permissionLevel,
		userId,
	})
}

function markSoftClaim(clientId, case_id) {
	return post(`/cases/mark-soft-claim?clientId=${clientId}`, {
		case_id,
	})
}

function unmarkSoftClaim(clientId, case_id) {
	return post(`/cases/unmark-soft-claim?clientId=${clientId}`, {
		case_id,
	})
}

export default withStyles(styles, { withTheme: true })(Violation)
